import React from 'react'

const IntegrationsAdsCard = () => {
  return (
    <div className=" w-full grid grid-cols-1 md:grid-cols-2 gap-16  items-center ">
      <div className=" w-full grid grid-cols-4 gap-4 md:gap-8  lg:p-8  order-last md:order-none ">
        <img
          src="https://media.tradly.app/images/marketplace/38667/633c70941b737616aefef393_mailchimp-logo-qRSCyh5k.svg"
          alt=""
        />
        <img
          src="https://media.tradly.app/images/marketplace/87037/633c7424ec242a1e4cfa8fc6_fullstory-logo-ZQVN4GNA.svg"
          alt=""
        />
        <img
          src="https://media.tradly.app/images/marketplace/23695/633c7010d2304ea97e6d2f88_google-analytics-Zn32OIEe.svg"
          alt=""
        />
        <img
          src="https://media.tradly.app/images/marketplace/14534/633c774f5eac62641b959747_hubspot-logo-wmziH2v6.svg"
          alt=""
        />
        <img
          src="https://media.tradly.app/images/marketplace/75784/633c76f094127552993360dd_intercom-logo-cyt1Bvrq.svg"
          alt=""
        />
        <img
          src="https://media.tradly.app/images/marketplace/67281/633c71fedaf66147e89c2835_amplitude-logo-AL5gOlRr.svg"
          alt=""
        />
        <img
          src="https://media.tradly.app/images/marketplace/87363/62d0d46f68ea16d26a2154ef_zapier-vcnaheYu.svg"
          alt=""
        />
        <img
          src="https://media.tradly.app/images/marketplace/11466/633c7398eb8f2c9b1f0cb12a_mixpanel-logo-FF60WZ0d.svg"
          alt=""
        />
      </div>

      {/* column 2 */}
      <div className=" flex flex-col gap-4 items-start  ">
        <p className=" text-primary bg-primary/20 px-2 rounded-full text-sm font-medium">
          Integrations
        </p>
        <h3 className=" h3 ">Connect all your apps</h3>
        <p className=" text-lightGray text-[18px] font-medium  leading-[27px] max-w-screen-md mr-0">
          Get more value out of your tools with a variety of direct integrations, extensible APIs,
          webhooks, and custom scripting.
        </p>

        <div className=" flex  flex-col  mt-2 md:mt-4">
          <button className=" btn_white_primary  !rounded-full">All Integrations</button>
        </div>
      </div>
    </div>
  )
}

export default IntegrationsAdsCard
